module.exports = __webpack_public_path__ + "static/media/Journey.315bad49.svg";